import React, { useEffect, useCallback } from "react"
import useHistoryState from "../useHistoryState"
import { useSelector } from "react-redux"
import {  RootReducer } from "../app/reducer"

export type OptionCl = {
    id: string,
    description: string
}

 type Props = {
    id? : string
    name: string
    options?: OptionCl[]
    label?: string
    reset?: number    
    csdOfIssuance?:boolean
}

export const InputCheckboxList : React.FC<Props> = props  => {    
    const windowHistoryState : any = useSelector((state:RootReducer) =>  state.securityResultReducer.secWindowHistoryState );
    const options = props.options ? props.options : []      
    const initialListValue = props.options ? props.options[0].description : ""
    //Set Initial state of the component
    const setInitialState = props.csdOfIssuance ? {disabledList: true, checkedCheckbox: true, disabledCheckbox: true} : {disabledList: true, checkedCheckbox: false, disabledCheckbox:false};
    const [state, setState] = useHistoryState(props.name, setInitialState);      
    const [listValue, setListState] = useHistoryState("list" + props.name, initialListValue);        
        
    //This useEffect is called when the component is mounted and when the props.reset is changed
    useEffect(() => {               
        if (props.reset !== 0) {              
            setState(setInitialState);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.reset])

    //The below useEffect is used to maintain history when moving between pages
    useEffect(() => {                                
        if ( windowHistoryState && windowHistoryState[props.name] ) {
            setState(windowHistoryState[ props.name])    
            setListState(windowHistoryState["list" + props.name])            
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [windowHistoryState])    

    //Called on onClick only
    const handleClick = useCallback(() => {
        if (! props.csdOfIssuance) {
            setState({disabledList: !state.disabledList, checkedCheckbox: !state.checkedCheckbox, disabledCheckbox: state.disabledCheckbox})}
            // eslint-disable-next-line react-hooks/exhaustive-deps
    },[state.checkedCheckbox, state.disabledList]);

    return(                
        <div className="search-table-row">          
            <span className="search-table-col-left">{props.label}</span>
            <span className="search-table-col-right">
                <input id={props.id + "Check"} type="checkbox" onClick={handleClick} checked={state.checkedCheckbox} disabled={state.disabledCheckbox}/>                                  

                <select id={props.id + "List"} name={props.name} disabled = {state.disabledList} value={listValue} onChange={e => setListState(e.target.value)} >                    
                    {options.map( option => <option key={option.id+option.description} value={option.id}>{option.description}</option>)}
                </select>                
            </span>            
        </div>
    )
}
